/**
 * Is this component rendered inside the PUBLIC Online Scheduler?
 *
 * WHY IT EXISTS: `ClientSearch` and `PropertyForm` are shared by the public Online Scheduler
 * (`schedule` pack) AND the staff-facing New Inspection / Quote forms (`inspection` pack). On the
 * public scheduler the person typing IS the client, so `autocomplete="given-name"`/`email`/`tel`
 * and the address tokens are exactly right. On the internal forms the person typing is an
 * inspector entering SOMEONE ELSE'S details, and the same tokens would invite the browser to
 * one-tap the staff member's own identity into a client record — a data-integrity bug, not a
 * cosmetic one. So autofill is gated on this predicate (SHUA-4323).
 *
 * `type` and `inputmode` are deliberately NOT gated: a correct keyboard is right in both
 * contexts, since it only affects what the person is already typing.
 *
 * The predicate lived as a local computed on `ClientSearch`; it moved here once `PropertyForm`
 * needed it too, so the route-name list is declared once.
 *
 * `$route` is guarded rather than assumed: both packs that mount these components install
 * VueRouter today (`packs/schedule.js`, `packs/inspection.js`), but a future router-less mount
 * should degrade to "not the public scheduler" — the safe default, which withholds autofill —
 * instead of throwing.
 */
export const ONLINE_SCHEDULER_ROUTE_NAMES = ['schedule', 'scheduleStep']

export default {
  computed: {
    renderedInOnlineScheduler() {
      return ONLINE_SCHEDULER_ROUTE_NAMES.includes(this.$route && this.$route.name)
    },
  },
}
